// IMPORTANT: These string values MUST match the `key` column for features in the backend database.
// They are used for programmatic checks (routing, widgets, guardrails, etc.).
export const FEATURE_TEMPO_KEY = "Tempo";
export const FEATURE_TRIPIST_KEY = "Tripist";
export const FEATURE_EXPLORIST_KEY = "Explorist";
export const FEATURE_AURA_KEY = "Aura";
export const FEATURE_LUMA_KEY = "Luma";


